import React from "react"
import { useTranslation } from "react-i18next"
import { PPDefaultSelector } from "../ui/PPDefaultSelector"

export default function PPMatchingFilterPanel({
    producerOptions,
    selectedProducer,
    onProducerChange,
    producersLoading,
    filterReady,
    minScore,
    onMinScoreChange,
    matchSourceOptions,
    selectedMatchSource,
    onMatchSourceChange,
    matchTypesLoading
}) {
    const [t] = useTranslation()

    return (
        <div className="pp-matching-toolbar__filters">
            <div className="pp-matching-toolbar__filters-grid">
                <div className="pp-matching-toolbar__filters-field">
                    <label className="pp-matching-toolbar__label">{t("matching.producer")}</label>
                    <PPDefaultSelector
                        id="matching-producer"
                        data={producerOptions}
                        value={selectedProducer}
                        onChange={(opt) => onProducerChange(opt?.value ?? null)}
                        isDisabled={producersLoading || !filterReady}
                        placeholder={t("matching.all_producers")}
                        menuInPortal
                    />
                </div>
                <div className="pp-matching-toolbar__filters-field">
                    <label className="pp-matching-toolbar__label">{t("matching.min_score")}</label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        min={0}
                        max={100}
                        value={minScore}
                        onChange={onMinScoreChange}
                    />
                </div>
                <div className="pp-matching-toolbar__filters-field">
                    <label className="pp-matching-toolbar__label">{t("matching.match_source")}</label>
                    <PPDefaultSelector
                        id="matching-source"
                        data={matchSourceOptions}
                        value={selectedMatchSource}
                        onChange={(opt) => onMatchSourceChange(opt?.value ?? "ALL")}
                        isDisabled={matchTypesLoading || !filterReady}
                        isClearable={false}
                        menuInPortal
                    />
                </div>
            </div>
        </div>
    )
}
